<div class="modal common-right-modal benefit-modal d-block" [ngClass]="{'show':showSlider}" id="ViewRuleConf" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-half">
        <div class="modal-content">
            <div class="modal-header upload-modal">
                <div class="title-head d-flex align-items-center">
                    <button id="btnAddGroupClose" type="button" class="btn-close tool-wrap position-relative" data-bs-dismiss="modal"
                    (click)="closePopup()" aria-label="Close">
                    <div class="custom-tooltip tooltip-top" role="tooltip">
                        <div class="arrow"></div>
                        <div class="tooltip-inner"> Close </div>
                      </div></button> 
                    <h2 class="modal-title" id="exampleModalToggleLabel">
                        <div class="d-flex align-items-center">
                            Rule Configurations
                        </div>
                    </h2>
                </div>
                <div class="btn-wrap" *ngIf="checkPermission('editRuleConfigVersion')|| checkPermission('editPayerRuleConfigVersion') || checkPermission('editProviderRuleConfigVersion') || checkPermission('editRuleConfigVersion')">
                    <button type="button" class="btn-text edit" data-bs-toggle="modal" (click)="configurationEdit()">Edit Details</button>
                </div>
            </div>
            <div class="modal-body insurance-modal">
                <div class="row">
                    <div class="col-6">
                        <div class="row mb-2" *ngIf="!systemConfigView">
                            <div class="col-5"><label class="form-label">{{setProviderPayer()}}</label></div>
                            <div class="col detail-view">
                                <span class="pointer">-</span>{{selectedConfig?.SubscriberName || selectedConfig?.payerName || selectedConfig?.providerName}}
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5"><label class="form-label">Version</label></div>
                            <div class="col detail-view"> <span class="pointer">-</span>{{selectedConfig?.version || selectedConfig?.payerRuleConfigurationVersion || 
                                selectedConfig?.providerRuleConfigurationVersion ||selectedConfig?.ruleConfigurationVersion || 'NA'}}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5"><label class="form-label">Calculate Best Package Size Based On</label></div>
                            <div class="col detail-view">
                                <span class="pointer">-</span>{{calBasedOn || 'NA'}}
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5"><label class="form-label">Max Refill</label></div>
                            <div class="col detail-view">
                                <span class="pointer">-</span>{{maxDuration || 'NA'}}
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5"><label class="form-label">Consider Drug In Hand</label></div>
                            <div class="col detail-view">
                                <span class="pointer">-</span>{{considerDrugInHand || 'NA'}}
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="row mb-2">
                            <div class="col-5"><label class="form-label">Validity</label></div>
                            <div class="col detail-view">
                                <span class="pointer">-</span>{{ruleConfigDetails?.[0]?.activeFrom | dateFormat}} - {{ruleConfigDetails?.[0]?.expiredOn | dateFormat}}
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5"><label class="form-label">Limit Dispense (Days)</label></div>
                            <div class="col detail-view"> <span class="pointer">-</span>{{limitDisQuanty || 'NA'}}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5"><label class="form-label">Refill Cut Off</label></div>
                            <div class="col detail-view"> <span class="pointer">-</span>{{refill || 'NA'}}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5"><label class="form-label">Dispense Type</label></div>
                            <div class="col detail-view">
                                <span class="pointer">-</span>{{dispenseType || 'NA'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="rd-head mt-3">
                            <h4><img src="assets/images/icons/drug-in-hand.svg" alt="drug icon"> Drug in Hand Expiry</h4>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="benefit-map-table mt-4">
                            <div class=" table-container">
                                <table class="table table-borderless table-bg">
                                    <caption class="d-none">Drug in Hand Expiry</caption>
                                    <thead>
                                        <tr>
                                            <th scope="col">Select the form of Drug</th>
                                            <th scope="col">Expiry (days)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let item of drugInHand">
                                            <tr>
                                                <td>{{item?.drugInForm}}</td>
                                                <td>{{item?.allowedDate}}</td>
    
                                            </tr>
                                            <tr class="spacer" *ngIf="drugInHand?.length"></tr>
                                        </ng-container>
                                        
                                        
                                    </tbody>
                                </table>
                            </div>
                            <app-navigation *ngIf="!showNavigation" [listLength]="totalCount" [pageNo]="page_no" (currentPageDetail)="currentPageDetail($event)" >
                            </app-navigation>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

